window.site =
    {
        base: {},
        product: {}
    }